const brandSetup = [
    { id: 0, title: 'General', url: 'brand_setup_general' },
    { id: 1, title: 'Checklist', url: 'brand_setup_checklist' },
    { id: 2, title: 'Configuration', url: 'brand_setup_configuration' },
    { id: 3, title: 'Payment', url: 'brand_setup_payment' }
]

let mySalons = []
if (window.location.href.includes('devbusiness') || window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
    mySalons = [
        { id: 'my_salon_member', title: 'Member', url: 'my_salon_member4', _subMenus:[],newTag:false },
        { id: 'my_salon_message', title: 'Message', url: 'my_salon_message', _subMenus:[],newTag:false },
        { id: 'my_salon_appointment', title: 'Appointment', url: 'my_salon_appointment3', _subMenus:[],newTag:true },
        { id: 'my_salon_staffs', title: 'Staffs', url: 'my_salon_staffs', _subMenus:[],newTag:false },
        { id: 'my_salon_user', title: 'User', url: 'my_salon_user', _subMenus:[],newTag:false },
        { id: 'my_salon_branding', title: 'Branding', url: 'my_salon_branding', _subMenus: brandSetup},
        { id: 'my_salon_setup', title: 'Setup', url: 'my_salon_setup', _subMenus: []},
        { id: 'my_salon_tukang', title: 'Tukang', url: 'my_salon_tukang', _subMenus: []},
        { id: 'my_salon_broadcast', title: 'Broadcast', url: 'my_salon_broadcast', _subMenus:[],newTag:false  },
        { id: 'my_salon_consentform', title: 'Consent Form', url: 'my_salon_consentform', _subMenus:[],newTag:false  },
    ]
} else {
    mySalons = [
        { id: 'my_salon_appointment3', title: 'APPOINTMENT', url: 'my_salon_appointment3', _subMenus:[],newTag:false },
    ]
}

const salonReportsOrder = [
    { id: 'salon_report_order', title: 'Order', url: 'salon_report_order' , _subMenus:[],newTag:false },
    { id: 'salon_report_delivery', title: 'Delivery', url: 'salon_report_delivery' , _subMenus:[],newTag:false },
]

let salonReports = [
    { id: 'salon_report_sales', title: 'Sales', url: 'salon_report_sales' , _subMenus:[],newTag:false },
    { id: 'salon_report_top_selling', title: 'Top Selling', url: 'salon_report_top_selling' , _subMenus:[],newTag:false },
    // { id: 'salon_report_payment', title: 'Payment', url: 'salon_report_payment' , _subMenus:[],newTag:false },
    { id: 'salon_report_payment', title: 'Payment', url: 'salon_report_payment2' , _subMenus:[],newTag:false },
    { id: 'salon_report_order', title: 'Order', url: 'salon_report_order' , _subMenus:salonReportsOrder,newTag:false },
    { id: 'salon_report_credit', title: 'Credits', url: 'salon_report_credit', _subMenus:[],newTag:false },
    { id: 'salon_report_voucher', title: 'Package', url: 'salon_report_voucher', _subMenus:[],newTag:false },
    { id: 'salon_report_points', title: 'Points', url: 'salon_report_points', _subMenus:[],newTag:false },
    { id: 'salon_report_outstandings', title: 'Outstandings', url: 'salon_report_outstandings', _subMenus:[],newTag:false },
    { id: 'salon_report_commission', title: 'Commission', url: 'salon_report_commission', _subMenus:[],newTag:false },
    { id: 'salon_report_stock', title: 'Stock', url: 'salon_report_stock2', _subMenus:[],newTag:false  },
    { id: 'salon_report_attendance', title: 'Attendance', url: 'salon_report_attendance', _subMenus:[],newTag:false  },
    // { id: 'salon_report_expenses', title: 'Expenses', url: 'salon_report_expenses', _subMenus:[],newTag:false  },
    // { id: 'salon_report_reward', title: 'Reward', url: 'salon_report_reward', _subMenus:[],newTag:false  },
    // { id: 'salon_report_visit', title: 'Visit', url: 'salon_report_visit', _subMenus:[],newTag:false},
    // { id: 'salon_report_poke', title: 'Poke', url: 'salon_report_poke', _subMenus:[],newTag:false},
    // { id: 'salon_report_cdr', title: 'CR', url: 'salon_report_cdr', _subMenus:[],newTag:false}
]
let salonReports2 = [
    { id: 'salon_report_commission2', url: 'salon_report_commission', _subMenus:[],newTag:false },
]

const salonMenus = [
    { id: 'salon_menu_service', title: 'Service', url: 'salon_menu_service3' , _subMenus:[],newTag:false },
    { id: 'salon_menu_product', title: 'Product', url: 'salon_menu_product3' , _subMenus:[],newTag:false },
    { id: 'salon_menu_package', title: 'Package', url: 'salon_menu_package3' , _subMenus:[],newTag:false },
    { id: 'salon_menu_discount', title: 'Discount', url: 'salon_menu_discount3' , _subMenus:[],newTag:false },
    // { id: 'salon_menu_treatment', title: 'Treatment', url: 'salon_menu_treatment' , _subMenus:[],newTag:false },
    { id: 'salon_menu_reward', title: 'Reward', url: 'salon_menu_reward', _subMenus:[],newTag:false },
    { id: 'salon_menu_configuration', title: 'Configuration', url: 'salon_menu_configuration', _subMenus:[],newTag:false },
]


const salonSettings = [
    // // { id: 'salon_setting_outlet', title: 'Outlet', url: 'salon_setting_outlet', _subMenus:[],newTag:false  },
    // { id: 'salon_setting_info', title: 'Information', url: 'salon_setting_info', _subMenus:[],newTag:false  },
    // { id: 'salon_setting_social', title: 'Social Media', url: 'salon_setting_social', _subMenus:[],newTag:false  },
    // { id: 'salon_setting_receipt', title: 'Receipt', url: 'salon_setting_receipt' , _subMenus:[],newTag:false },
    // { id: 'salon_setting_booking', title: 'Booking', url: 'salon_setting_booking', _subMenus:[],newTag:false  },
    // { id: 'salon_setting_booking_block', title: 'Booking (Black List)', url: 'salon_setting_booking_block', _subMenus:[],newTag:false  },
    // // { id: 'salon_setting_staff', title: 'Staff', url: 'salon_setting_staff3', _subMenus:[],newTag:false  },  
    // // { id: 'salon_setting_roster', title: 'Staff Roster', url: 'salon_setting_roster', _subMenus:[],newTag:false  },  
    // { id: 'salon_report_roster', title: 'Staff Roster', url: 'salon_report_roster2', _subMenus:[],newTag:false  },  
    // { id: 'salon_report_room', title: 'Room', url: 'salon_report_room', _subMenus:[],newTag:false  },  
    // // { id: 'salon_setting_washer', title: 'Car Wash', url: 'salon_setting_washer', _subMenus:[],newTag:false },
    // { id: 'salon_setting_setup', title: 'Setup', url: 'salon_setting_setup', _subMenus:[],newTag:false }
]

if (window.location.href.includes('devbusiness') || window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
    // salonSettings.push(
    //     { id: 'salon_setting_outlet', title: 'Outlet', url: 'salon_setting_outlet', _subMenus:[],newTag:false  },
    // )
    // salonSettings.push(
    //     { id: 'salon_setting_staff', title: 'Staff', url: 'salon_setting_staff3', _subMenus:[],newTag:false  },        
    // )
    // salonSettings.push(
    //     { id: 'salon_setting_security', title: 'Security Configuration', url: 'salon_setting_security', _subMenus:[],newTag:false },        
    // )
    salonSettings.push(
        { id: 'salon_setting_security', title: 'SECURITY CONFIGURATION', url: 'salon_setting_security', _subMenus:[],newTag:false },        
    )
}

const roster = [
    { id: 'roster_staff_scheme', title: 'Staff Scheme', url: 'roster_staff_scheme', _subMenus:[],newTag:false  },
    { id: 'roster_leave_request', title: 'Leave Request', url: 'roster_leave_request', _subMenus:[],newTag:false  },
    { id: 'roster_off_day', title: 'Off Day', url: 'roster_off_day', _subMenus:[],newTag:false  },
]


const sideNavs = [
    // {   
    //     listId: 0,
    //     id: "navDashboard",
    //     title: "DASHBOARD",
    //     subMenus: [],
    //     icon: "fa-chart-line"
    // },
    {   
        listId: 1,
        id: "navMySalon",
        title: "MY SALON",
        subMenus: mySalons,
        // icon: "fa-home"
        icon: "fa-calendar"
    },
    // {
    //     listId: 2,
    //     id: "navSalonReport",
    //     title: "SALON REPORT",
    //     subMenus: salonReports,
    //     icon: "fa-ballot"
    // },
    // {
    //     listId: 4,
    //     id: "navSalonSetting",
    //     title: "OUTLET SETTING",
    //     subMenus: salonSettings,
    //     icon: "fa-store"
    // },
]

if (window.location.href.includes('devbusiness') || window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
    sideNavs.push({
        listId: 2,
        id: "navSalonReport",
        title: "SALON REPORT",
        subMenus: salonReports,
        icon: "fa-ballot"
    })

    sideNavs.push({
        listId: 4,
        id: "navSalonSetting",
        title: "OUTLET SETTING",
        subMenus: salonSettings,
        icon: "fa-store"
    })

    sideNavs.push({
        listId: 3,
        id: "navSalonMenu",
        title: "SALON MENU",
        subMenus: salonMenus,
        icon: "fa-book-open"
    })
    
    sideNavs.push({
        listId: 5,
        id: "navRoster",
        title: "ROSTER",
        subMenus: roster,
        icon: "fa-clipboard-user"
    })
} else {
    sideNavs.push({
        listId: 2,
        id: "navSalonReport2",
        title: "SALON REPORT",
        subMenus: salonReports2,
        icon: "fa-ballot"
    })
}

module.exports = {
    sideNavs
}
